import { Box, Input, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";

import { keyframes } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import { getAugmentedStyle } from "../utils/augmentedStyles";
import { transform } from "framer-motion";

const blockInvalidChar = (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
const blink = keyframes`from,
49.8%{
  opacity: 1;
}
49.9%,
99.9% {
  opacity: 0;
}
to {
  opacity: 1;
}`;

function SplitByDigitInput({
  name,
  length = 6,
  scale = 1,
  code,
  setCode,
  isError,
  setIsError,
  sx,
  inputsSx,
  autoFocus = true,
  width = "400px"
}) {
  const theme = useTheme();
  const [focused, setFocused] = useState(false);

  const handleChange = (e) => {
    if (code.length < length || e.nativeEvent.inputType === "deleteContentBackward") {
      setCode(e.target.value);
      if (setIsError) setIsError(false)
    }
  };
  useEffect(() => {
    if (code.length > length) setCode((prev) => prev.slice(0, length));
  }, [code, length, setCode]);

  return (
    <Box
      sx={{
        position: "relative",
        transform: `scale(${scale})`,
        ...sx
      }}
    >
      <Box
        sx={{
          display: "flex",
          position: "absolute",
          justifyContent: "center",
          ...inputsSx
        }}>
        {[...Array(length)].map((value, index) => (
          <Box
            key={index}
            style={getAugmentedStyle({
              color: isError ? '#FF8399' : theme.palette.grey[focused && index === code.length ? 80 : 30],
              borderSize: "2px"
            })}
            data-augmented-ui="br-clip border"
            sx={{
              display: "flex",
              width: { xxs: "32px", md: "45.5px" },
              height: { xxs: "42px", md: "65px" },
              justifyContent: "center",
              alignItems: "center",
              mr: index + 1 < length ? 1.5 : 0,
              color: isError ? "#FF8399" : 'white'
            }}>
            {index === code.length ? (
              <Typography
                sx={{
                  display: focused ? "block" : "none",
                  fontSize: 34.67,
                  content: '""',
                  position: "absolute",
                  width: "1px",
                  height: { xxs: 20, md: 35 },
                  background: (theme) => theme.palette.primary.main,
                  left: "50%",
                  top: "50%",
                  transform: "translate3d(-50%, -50%, 0)",
                  animation: `${blink} 1s linear infinite`
                }}>
                {code[index] || ""}
              </Typography>
            ) : (
              <Typography sx={{ fontSize: { xs: 22, md: 34.67 } }}>{code[index] || ""}</Typography>
            )}
          </Box>
        ))}
      </Box>
      <Input
        key={name}
        onKeyDownCapture={blockInvalidChar}
        value={code}
        disableUnderline={true}
        maxLength={length}
        onChange={handleChange}
        type="number"
        autoComplete="off"
        autoFocus={autoFocus}
        onFocus={(event) => {
          setFocused(true);
          // event.target.select();
        }}
        onBlur={() => {
          setFocused(false);
        }}
        onWheel={(event) => event.target.blur()}
        sx={{
          "& .MuiInput-input": {
            "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
              WebkitAppearance: "none"
            }
          },
          "input": {
            height: "100%"
          },
          width: { xxs: "280px", md: width },
          height: { xxs: "42px", md: "65px" },
          caretColor: "transparent",

          color: "transparent",
          backgroundColor: "transparent",
          textShadow: "transparent",
          p: 0
        }}
      />
    </Box>
  );
}

export default SplitByDigitInput;
